import { Link } from "react-router-dom";
import PageMeta from "@/components/base/PageMeta";
import Breadcrumb from "@/components/base/Breadcrumb";

const VALUES = [
  {
    icon: "ri-film-line",
    title: "作品档案完整",
    desc: "系统性整理佐山爱出演的电影与电视剧，涵盖类型、年份、演职人员与剧情简介。",
  },
  {
    icon: "ri-newspaper-line",
    title: "动态更新及时",
    desc: "持续跟进新片资讯、活动报道与专访内容，让你不错过任何一条重要消息。",
  },
  {
    icon: "ri-search-eye-line",
    title: "浏览查找便捷",
    desc: "支持类型筛选、排序与关键词搜索，几秒钟就能定位到你想看的那一部作品。",
  },
];

export default function About() {
  return (
    <div className="pt-16 md:pt-[72px]">
      <PageMeta
        title="关于佐山爱 - 影视品牌站介绍"
        description="了解佐山爱影视品牌站的定位与内容，本站专注整理佐山爱的影视作品档案与明星动态资讯，为影迷提供清晰便捷的浏览入口。"
        keywords="关于佐山爱,佐山爱官网,影视品牌站,影迷资讯平台"
      />

      <section className="px-5 md:px-10 pt-10 md:pt-14 pb-10 bg-background-100">
        <div className="mb-5">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于佐山爱" }]} />
        </div>
        <span className="text-xs font-medium tracking-[0.2em] uppercase text-accent-600">
          About
        </span>
        <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mt-3 mb-4">
          关于佐山爱
        </h1>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
          本站是一个以「佐山爱」为核心的影视品牌展示与影迷资讯平台，
          专注于整理她的影视作品档案与明星动态，为粉丝与影视爱好者提供清晰、完整、舒适的浏览体验。
        </p>
      </section>

      <section className="px-5 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20editorial%20photograph%20of%20a%20vintage%20film%20projector%20casting%20a%20soft%20golden%20light%20beam%20in%20a%20quiet%20dark%20studio%20room%2C%20deep%20navy%20shadows%20and%20amber%20glow%2C%20cinematic%20nostalgic%20composition%2C%20no%20people%2C%20elegant%20and%20calm&width=1200&height=900&seq=wk-about-01&orientation=landscape"
              alt="影视放映场景"
              title="关于佐山爱 - 影视品牌站"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <h2 className="font-heading font-semibold text-2xl text-foreground-950 mb-4">
              我们的初衷
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-loose mb-4">
              好作品值得被认真对待。我们希望把佐山爱这些年塑造的一个个角色，
              以及镜头之外那些真实的瞬间，用最清晰的方式呈现给你。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-loose">
              无论你是从某部电影开始认识她，还是一路陪伴的老影迷，
              这里都能找到属于你的那一份回忆与期待。
            </p>
          </div>
        </div>
      </section>

      <section className="px-5 md:px-10 py-12 md:py-16 bg-background-100">
        <div className="mb-8 md:mb-10">
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-accent-600">
            What We Offer
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
            网站提供什么
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {VALUES.map((value) => (
            <div
              key={value.title}
              className="p-6 md:p-7 rounded-lg bg-background-50 border border-background-200/70"
            >
              <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary-100 text-primary-700 mb-5">
                <i className={`${value.icon} text-2xl`} />
              </span>
              <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">
                {value.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{value.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="px-5 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-8 lg:gap-12">
          <div>
            <h2 className="font-heading font-semibold text-2xl text-foreground-950 mb-4">
              联系与反馈
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              如果你对本站的内容有任何建议，或是想补充某条作品信息，
              欢迎通过以下方式与我们联系。我们期待听到每一位影迷的声音。
            </p>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3 text-sm text-foreground-700">
                <span className="flex items-center justify-center w-9 h-9 rounded-md bg-background-100 text-primary-600">
                  <i className="ri-mail-line" />
                </span>
                contact@sayama-ai-demo.example
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-700">
                <span className="flex items-center justify-center w-9 h-9 rounded-md bg-background-100 text-primary-600">
                  <i className="ri-time-line" />
                </span>
                工作日 10:00 - 18:00（演示信息）
              </div>
            </div>
          </div>

          <div className="p-6 md:p-8 rounded-lg bg-secondary-50 border border-secondary-200">
            <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-3">
              关于本站内容
            </h3>
            <p className="text-sm text-foreground-600 leading-loose mb-5">
              本站展示的所有影视作品名称、制作公司、导演与演员信息均为演示用的虚构内容，
              不代表任何真实影视资料。收藏功能仅保存在你的浏览器本地，不会上传到服务器。
            </p>
            <Link
              to="/works"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-grid-line" />
              去看看影视作品
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}